<div class="col-md-12 col-lg-12">
    <div class="col-sm-3">
        <h4><b>{{ 'pages.createReceiptPage.sizes' | translate}}</b></h4>
    </div>
    <div [@openClose]="!isOpen ? 'open' : 'closed'">
        <div class="col-sm-3">
            <h4>{{selectedPackaging}}</h4>
        </div>
    </div>
</div>

<div class="col-md-3 col-sm-10">
    <button class="btn btn-lg r btn-mode" (click)="getShipmentPackagingPrices('Small')">
        <span class="armx-icon armx-resize-small"></span>
        <div class="btn-text">
            <span class="size-name">{{ 'common.small' | translate }}</span>
            <span class="price">{{ this.packagingSmall + ' ' + this.BranchCurrencyCode }}</span>
        </div>
    </button>
</div>

<div class="col-md-3 col-sm-10">
    <button class="btn btn-lg r btn-mode" (click)="getShipmentPackagingPrices('Medium')">
        <span class="armx-icon armx-medium"></span>
        <div class="btn-text">
            <span class="size-name">{{ 'common.medium' | translate }}</span>
            <span class="price">{{ this.packagingMedium + ' ' + this.BranchCurrencyCode }}</span>
        </div>
    </button>
</div>

<div class="col-md-3 col-sm-10">
    <button class="btn btn-lg r btn-mode" (click)="getShipmentPackagingPrices('Large')">
        <span class="armx-icon armx-resize-full"></span>
        <div class="btn-text">
            <span class="size-name">{{ 'common.big' | translate }}</span>
            <span class="price">{{ this.packagingLarge + ' ' + this.BranchCurrencyCode }}</span>
        </div>
    </button>
</div>



